import React, { useState } from "react";
import "./App.css"; // Zorg ervoor dat je Tailwind CSS hebt toegevoegd
import { DynamicForm } from "./form/DynamicForm";
import { ConfiguratorContainer } from "./configurator/ConfiguratorContainer";
import { OrderSummary } from "./order/OrderSummary";
import { TotalPrice } from "./order/TotalPrice";
import { OrderForm } from "./order/OrderForm";
import { OrderConfirmation } from "./order/OrderConfirmation";
import { calculate_price } from "./order/Calculate_price";
import { FormProvider, useForm } from "react-hook-form";
import { formConfig } from "./form/formConfig";
import { LoadingProvider, useLoading } from "./contexts/LoadingContext";

// WebSocket status indicator component
const WebSocketStatus = () => {
  const { isWebSocketConnected, hasTimedOut } = useLoading();

  // Determine status: timeout takes priority over connection status
  const getStatusConfig = () => {
    if (hasTimedOut) {
      return {
        bgClass: 'bg-amber-100/90 text-amber-700',
        dotClass: 'bg-amber-500 animate-pulse',
        opacity: '', // Always visible when timed out
        title: 'Backend reageert niet (timeout)',
        label: 'Timeout'
      };
    }
    if (isWebSocketConnected) {
      return {
        bgClass: 'bg-green-100/80 text-green-700',
        dotClass: 'bg-green-500',
        opacity: 'opacity-30 hover:opacity-100',
        title: 'Verbonden met server',
        label: 'Online'
      };
    }
    return {
      bgClass: 'bg-red-100/90 text-red-700',
      dotClass: 'bg-red-500 animate-pulse',
      opacity: '',
      title: 'Niet verbonden met server',
      label: 'Offline'
    };
  };

  const status = getStatusConfig();

  return (
    <div
      className={`fixed bottom-3 left-3 z-50 flex items-center gap-1.5 px-2 py-1 rounded-lg text-xs font-medium transition-all duration-300 ${status.bgClass} ${status.opacity}`}
      style={{
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)'
      }}
      title={status.title}
    >
      <div
        className={`w-1.5 h-1.5 rounded-full ${status.dotClass}`}
      />
      <span>{status.label}</span>
    </div>
  );
};

const default_orders = [];

// Build default values from formConfig
const getDefaultValues = () => {
  const defaults = {};
  formConfig.forEach((config) => {
    if (config.defaultValue !== undefined) {
      defaults[config.name] = config.defaultValue;
    }
  });
  return defaults;
};

function App() {
  const methods = useForm({
    mode: "onSubmit",
    defaultValues: getDefaultValues()
  });

  const [orders, setOrders] = useState(default_orders);
  const [page, setPage] = useState("CONFIGURATOR");
  const [orderNumber, setOrderNumber] = useState(null);

  console.log("rerender app.js")

  const remove_opmeting = () => {
    const new_orders = [...orders];
    setOrders(new_orders.map((no) => ({ ...no, OPMETING: false })));
  };

  const add_order = (order) => {
    const new_orders = [...orders];
    const new_order = calculate_price(order);
    console.log(new_order);
    new_orders.push(new_order);
    setOrders(new_orders);
  };

  const remove_from_card = (index) => {
    setOrders((prevOrders) => prevOrders.filter((_, i) => i !== index));
  };

  const handleStartOrder = () => {
    setPage("ORDER_FORM");
  };

  const handleOrderSubmit = async (customerInfo) => {
    try {
      // Get current form values
      const formValues = methods.getValues();

      // Calculate total price
      const totalPrice = calculate_price(formValues).prijs;

      // Prepare order data
      const orderData = {
        totalPrice,
        configuration: formValues
      };

      // Build API endpoint from environment variable
      const apiBaseUrl = process.env.REACT_APP_API_URL || '';
      const apiUrl = apiBaseUrl ? `${apiBaseUrl}/api/submit-order` : '/api/submit-order';

      console.log('Environment:', process.env.REACT_APP_ENV);
      console.log('Submitting order to:', apiUrl);
      console.log('Order data:', { customerInfo, orderData, configurationData: formValues });

      // Submit to backend API
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          customerInfo,
          orderData,
          configurationData: formValues
        })
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('API Error:', response.status, errorText);
        throw new Error(`Failed to submit order: ${response.status}`);
      }

      const result = await response.json();
      console.log('Order submitted successfully:', result);

      // Store order number and show confirmation
      setOrderNumber(result.orderNumber);
      setPage("ORDER_CONFIRMATION");

    } catch (error) {
      console.error('Error submitting order:', error);
      throw error; // Re-throw to be handled by OrderForm
    }
  };

  const handleOrderComplete = () => {
    // Reset form and return to configurator
    methods.reset(getDefaultValues());
    setOrderNumber(null);
    setPage("CONFIGURATOR");
  };

  const RenderContainer = () => {
    switch (page) {
      case "SHOPPINGBASKET":
        return (
          <OrderSummary
            remove_from_card={remove_from_card}
            remove_opmeting={remove_opmeting}
            closeBasket={() => {
              setPage("CONFIGURATOR");
            }}
            orders={orders}
          />
        );
      case "ORDER_FORM":
        const formValues = methods.getValues();
        const totalPrice = calculate_price(formValues).prijs;
        return (
          <OrderForm
            onBack={() => setPage("CONFIGURATOR")}
            onSubmit={handleOrderSubmit}
            orderData={{ totalPrice }}
          />
        );
      case "ORDER_CONFIRMATION":
        return (
          <OrderConfirmation
            orderNumber={orderNumber}
            onClose={handleOrderComplete}
          />
        );
      default:
        return (
          <DynamicForm
            add_order={add_order}
            orders={orders}
            openBasket={() => setPage("SHOPPINGBASKET")}
          />
        );
    }
  };

  return (
<LoadingProvider>
<FormProvider
    {...methods}
    >
      <div className="page-container">
        <div className="main-container">
          {/* Left side: 3D Configurator */}
          <div className="configurator relative">
            <ConfiguratorContainer />
            <div
              className="absolute bottom-8 info-banner flex items-center gap-2.5 px-4 py-2.5 bg-white/70 border border-gray-200/60 rounded-2xl shadow-sm backdrop-blur-sm z-10 transition-all duration-200 hover:bg-white/80 hover:shadow-md"
              role="alert"
              style={{
                backdropFilter: 'blur(20px) saturate(180%)',
                WebkitBackdropFilter: 'blur(20px) saturate(180%)'
              }}
            >
              <svg
                className="flex-shrink-0 w-4 h-4 text-gray-500"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
              </svg>
              <span className="sr-only">Info</span>
              <div className="text-xs font-normal text-gray-600">
                De werkelijke kleuren kunnen licht afwijken van de weergave op het scherm
              </div>
            </div></div>
          

          {/* Right side: Form to configure the flying frame */}
          <div className="form-container ">
            <div className="top pb-0">
              <RenderContainer />
            </div>

            {/* TotalPrice outside scroll area, positioned at bottom - only show on configurator and basket pages */}
            {(page === "CONFIGURATOR" || page === "SHOPPINGBASKET") && (
              <div className="bottom-fixed">
                <div className="mx-4 mb-4 bg-white/60 rounded-2xl shadow-sm border border-gray-200/60 transition-all duration-200 hover:bg-white/80 hover:shadow-md backdrop-blur-sm" style={{
                  backdropFilter: 'blur(20px) saturate(180%)',
                  WebkitBackdropFilter: 'blur(20px) saturate(180%)'
                }}>
                  <TotalPrice
                    orders={orders}
                    openBasket={() => setPage("SHOPPINGBASKET")}
                    onStartOrder={handleStartOrder}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      </FormProvider>
      <WebSocketStatus />
</LoadingProvider>
  );
}

export default App;
